import Closed from './closed.webp';
import Logo from './logo.webp';
import Outside from './outside.webp';
import TrainDoors from './traindoors.webp';
import Trains from './Trains.webp';

export default {
    Closed,
    Logo,
    Outside,
    TrainDoors,
    Trains
}